import { Component, OnInit, EventEmitter, ViewChild, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
// import { GrantsCriteriaService } from 'src/app/services/grants/grants-criteria.service';
import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';
// import { AppFunctionsService } from 'src/app/services/app-functions.service';
// import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { CommonService } from 'src/app/services/common.service';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import * as $ from 'jquery';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HeadService } from 'src/app/services/common/headservice';
import { GrantsDatashareService } from 'src/app/services/grants/grants-datashare.service';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { Router } from '@angular/router';
// import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-grants-authorized-signee-and-payee-view-modal',
  templateUrl: './grants-authorized-signee-and-payee-view-modal.component.html',
  styleUrls: ['./grants-authorized-signee-and-payee-view-modal.component.scss']
})
export class GrantsAuthorizedSigneeAndPayeeViewModalComponent implements OnInit {
  staticformFields: any;
  prefixList : any[];
  @Input() public Content: any;
  formFields;
  appid: string = "";
  authorizedSigneePayeeForm: UntypedFormGroup;
  content: any;
  action: Subject<any> = new Subject();
  permission: string;
  formData: FormData;
  humanizeBytes: Function;
  dragOver: boolean;
  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;

  constructor(
    private summaryService: GrantsSummaryService,
    public modalRef: NgbActiveModal,
    private grantsDatashare:GrantsDatashareService,
    private header:HeadService,
    private modalService:NgbModal,
    private router: Router,
    private commonService: CommonService)  { }

  ngOnInit() {
    this.getStaticFiledsData('SCR-028');
   
    var grantapp = this.commonService.getGrantsApp();
    this.appid = grantapp.ID;
    let MenuModule=this.commonService.getModuleMenu();
    this.getOnIntMethods()
  }

getOnIntMethods()
{
  this.GetMasterData();

  this.authorizedSigneePayeeForm = new UntypedFormGroup({
    ID: new UntypedFormControl(null),
    APPLICATION_ID: new UntypedFormControl(null),
    PREFIX: new UntypedFormControl("", [Validators.required]),
    FIRST_NAME: new UntypedFormControl("", [Validators.required]),
    MIDDLE_NAME: new UntypedFormControl(""),
    LAST_NAME: new UntypedFormControl("", [Validators.required]),
    EMAIL: new UntypedFormControl("", [Validators.required]),
    ADDRESS: new UntypedFormControl("", [Validators.required]),
    IS_DEFAULT_CONTACT: new UntypedFormControl(false),
    REGISTRATION_ID: new UntypedFormControl(null)
  });
  if (this.Content.heading == "View") {
    this.GetEditData();
    this.authorizedSigneePayeeForm.disable();
  }
  if (this.Content.heading == "Edit") {
    this.GetEditData();
  }
  this.permission = this.commonService.getPagePermission("GC07").toLowerCase();
  if (this.permission === 'view') {
    setTimeout(() => {
      this.authorizedSigneePayeeForm.disable({ emitEvent: false });
    }, 100);
  }
}

  GetEditData(): void {
    this.summaryService.getSignee(this.Content.content.id).subscribe(summary => {
      this.authorizedSigneePayeeForm.patchValue({
        ID: summary["ID"],
        APPLICATION_ID: summary["APPLICATION_ID"],
        PREFIX: summary["PREFIX"],
        FIRST_NAME: summary["FIRST_NAME"],
        MIDDLE_NAME: summary["MIDDLE_NAME"],
        LAST_NAME: summary["LAST_NAME"],
        EMAIL: summary["EMAIL"],
        ADDRESS: summary["ADDRESS"],
        IS_DEFAULT_CONTACT: summary["IS_DEFAULT_CONTACT"],
        REGISTRATION_ID: summary["REGISTRATION_ID"]
      });
      this.extendedForm.rowid=summary.ID;
      this.extendedForm.getResponse();
    });
   
  }
  getStaticFiledsData(screenCode:string) {
    this.commonService.getScreenStaticFields(screenCode)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
      });
  }
  ClosePopup() {
    this.modalRef.close();
  }

  GetMasterData() {
    this.prefixList = [];
    var signeeId="-1";
    
    if (this.Content.content !== null && this.Content.content !== undefined && this.Content.content.id !== undefined && this.Content.content.id !== null)
    {
      signeeId=this.Content.content.id;
    }
      this.summaryService.GetMasterScreenData("api/gmsignee/getmasterdata/" +signeeId).subscribe(summary => {
      this.prefixList = summary["MasterData3"];
      this.prefixList = [{ label: "Select", value: null, checked: true }].concat(this.prefixList);
    });
  }

  
  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.authorizedSigneePayeeForm.value;
    if (this.staticformFields?.PREFIX.IS_Display && this.staticformFields?.PREFIX.IS_MANDATORY) {
      if (formData.PREFIX === null || formData.PREFIX === "") {
        $("#PREFIX").addClass("ng-touched ng-invalid validate-error");
        $("#PREFIX").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.PREFIX.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#PREFIX").addClass("ng-untouched ng-valid");
        $("#PREFIX").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.FIRST_NAME.IS_Display && this.staticformFields?.FIRST_NAME.IS_MANDATORY) {
    if (formData.FIRST_NAME === null || formData.FIRST_NAME === "" || formData.FIRST_NAME === undefined) {
      $("#FIRST_NAME").addClass("ng-touched ng-invalid validate-error");
      $("#FIRST_NAME").removeClass("ng-untouched ng-valid");
      message +=  `Please enter ${this.staticformFields?.FIRST_NAME.LABEL_NAME} <br/>`;
      isValid = false;
    } else {
      $("#FIRST_NAME").addClass("ng-untouched ng-valid");
      $("#FIRST_NAME").removeClass("ng-touched ng-invalid validate-error");
    }
  }
  
  if (this.staticformFields?.MIDDLE_NAME.IS_Display && this.staticformFields?.MIDDLE_NAME.IS_MANDATORY) {
    if (formData.MIDDLE_NAME === null || formData.MIDDLE_NAME === "" || formData.MIDDLE_NAME === undefined) {
      $("#MIDDLE_NAME").addClass("ng-touched ng-invalid validate-error");
      $("#MIDDLE_NAME").removeClass("ng-untouched ng-valid");
      message +=  `Please enter ${this.staticformFields?.MIDDLE_NAME.LABEL_NAME} <br/>`;
      isValid = false;
    } else {
      $("#MIDDLE_NAME").addClass("ng-untouched ng-valid");
      $("#MIDDLE_NAME").removeClass("ng-touched ng-invalid validate-error");
    }
  }

  if (this.staticformFields?.LAST_NAME.IS_Display && this.staticformFields?.LAST_NAME.IS_MANDATORY) {
    if (formData.LAST_NAME === null || formData.LAST_NAME === "" || formData.LAST_NAME === undefined) {
      $("#LAST_NAME").addClass("ng-touched ng-invalid validate-error");
      $("#LAST_NAME").removeClass("ng-untouched ng-valid");
      message +=  `Please enter ${this.staticformFields?.LAST_NAME.LABEL_NAME} <br/>`;
      isValid = false;
    } else {
      $("#LAST_NAME").addClass("ng-untouched ng-valid");
      $("#LAST_NAME").removeClass("ng-touched ng-invalid validate-error");
    }
  }

  if (this.staticformFields?.ADDRESS.IS_Display && this.staticformFields?.ADDRESS.IS_MANDATORY) {
  if (formData.ADDRESS === null || formData.ADDRESS === "") {
    $("#ADDRESS").addClass("ng-touched ng-invalid validate-error");
    $("#ADDRESS").removeClass("ng-untouched ng-valid");
    message +=  `Please enter ${this.staticformFields?.ADDRESS.LABEL_NAME} <br/>`;
    isValid = false;
  } else {
    $("#ADDRESS").addClass("ng-untouched ng-valid");
    $("#ADDRESS").removeClass("ng-touched ng-invalid validate-error");
  }
  }

  if (this.staticformFields?.EMAIL.IS_Display && this.staticformFields?.EMAIL.IS_MANDATORY) {
    if (formData.EMAIL === null || formData.EMAIL === "" || formData.EMAIL === undefined) {
      $("#EMAIL").addClass("ng-touched ng-invalid validate-error");
      $("#EMAIL").removeClass("ng-untouched ng-valid");
      message +=  `Please enter ${this.staticformFields?.EMAIL.LABEL_NAME} <br/>`;
      isValid = false;
    } else {
      const mailformat = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
      if (formData.EMAIL.match(mailformat)) {
        $("#EMAIL").addClass("ng-untouched ng-valid");
        $("#EMAIL").removeClass("ng-touched ng-invalid validate-error");
      }
      else {
        $("#EMAIL").addClass("ng-touched ng-invalid validate-error");
        $("#EMAIL").removeClass("ng-untouched ng-valid");
        message += `Please enter Valid ${this.staticformFields?.EMAIL.LABEL_NAME}<br/>`;
        isValid = false;
      }
    }
  }

  //dyamic fields validations
  let ExtenMsgs = this.extendedForm.validateControlsMsgs();
  if (ExtenMsgs != null && ExtenMsgs != undefined && ExtenMsgs.length > 0) {
    isValid = false;
    message = message + ExtenMsgs;
  }

    if (!isValid)
     this.commonService.ValidationBanner(message);
     return isValid;
  }

  SaveSignee() {
    debugger
    if (this.validateControls()) {
      var formDate = this.authorizedSigneePayeeForm.value;
      formDate["APPLICATION_ID"] = this.appid;
      // formDate["PHONE_EXT"] = parseInt(formDate["PHONE_EXT"]);
      formDate["GRANTTYPE"] = this.commonService.getModuleName();
      if (this.Content.heading == "Add") {
        this.summaryService.Insert('api/gmsignee/insert', formDate).subscribe(summary => {
          if (summary.Status === 0) {
          this.extendedForm.saveControls(summary.TransactionID,this.appid,summary.TransactionCode).subscribe(result => {
            if (result.Status === 0) {
              this.commonService.SuccessBanner(summary.Message);
              this.modalRef.close();
            }
            else {
              this.commonService.ValidationBanner(result.Message);
            }
          });
        }
        else
        {
          this.commonService.ValidationBanner(summary.Message);
        }
        });
      }
      else {
        this.summaryService.Update('api/gmsignee/update', formDate).subscribe(summary => {
          if (summary.Status === 0 ||summary.ErrorCode=="NOCHANGES") {
          this.extendedForm.saveControls(summary.TransactionID,this.appid,summary.TransactionCode).subscribe(summary1 => {
            if(summary1.ErrorCode === "NOCONTROLS")
            {
              if (summary.Status === 0) {
                this.commonService.SuccessBanner(summary.Message);
                this.modalRef.close();
              }
              else {
                this.commonService.ValidationBanner(summary.Message);
              }
            }else{
              if (summary.ErrorCode === "NOCHANGES" && summary1.ErrorCode === "NOCHANGES") {
                this.commonService.ValidationBanner(summary.Message);
              }
              else {
                //this.commonService.SuccessBanner(summary.Message);
                this.commonService.SuccessBanner('Authorized Signee and Payee updated successfully');
                  this.modalRef.close();
              }
            }
           
          });
        }
        else{
          this.commonService.ValidationBanner(summary.Message);
        }
        });
      }
    }
  }

  copyFromReg() {
    this.GetCopyData();
  }

  GetCopyData(): void {
    debugger;
    this.summaryService.getSigneeCopyData(this.appid).subscribe(summary => {
      this.authorizedSigneePayeeForm.patchValue({
       // ID: summary["ID"],
        APPLICATION_ID: summary["APPLICATION_ID"],
        PREFIX: summary["PREFIX"],
        FIRST_NAME: summary["FIRST_NAME"],
        MIDDLE_NAME: summary["MIDDLE_NAME"],
        LAST_NAME: summary["LAST_NAME"],
        EMAIL: summary["EMAIL"],
        ADDRESS: summary["ADDRESS"],
        IS_DEFAULT_CONTACT: summary["IS_DEFAULT_CONTACT"],
       // REGISTRATION_ID: summary["REGISTRATION_ID"]
      });
    });
  }


}
